module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"purchased_at":"{0} 구매","best_review_reward":"우수 리뷰 선정 시 최대 {0} 지급!"}}')
  delete Component.options._Ctor
}
